import { connect } from 'react-redux'
import cx from 'classnames'
import _ from 'lodash'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import confUtil from '../../../../lib/confUtil'
import { NothingBlock } from '../YCard'
import styles from './index.css'

const CUSTOM_PROPOSAL_TYPE_MAP = {
  [PROPOSAL_TYPE.UPDATE_LISTING]: '賣場資訊',
  [PROPOSAL_TYPE.UPDATE_IMAGE]: '圖片',
  [PROPOSAL_TYPE.UPDATE_ATTRIBUTE]: '規格表',
  [PROPOSAL_TYPE.UPDATE_VIDEO]: '影片',
  [PROPOSAL_TYPE.UPDATE_COPY]: '詳情與保證'
}

const getPermissionStr = proposalTypes => {
  const permissionStr = _.flow(
    () => _.map(proposalTypes, proposalType => {
      return `「修改${_.get(CUSTOM_PROPOSAL_TYPE_MAP, proposalType, proposalType)}提案」`
    }),
    proposalTypeNames => _.join(proposalTypeNames, '、')
  )()
  return permissionStr
}

const REQUIRED_PERMISSION_STR = getPermissionStr([
  PROPOSAL_TYPE.UPDATE_LISTING,
  PROPOSAL_TYPE.UPDATE_IMAGE,
  PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
  PROPOSAL_TYPE.UPDATE_VIDEO,
  PROPOSAL_TYPE.UPDATE_COPY
])

const UpdateListingNoPrivilegedPermission = props => {
  const {
    paths = [],
    privilegedPages = []
  } = props
  const privilegedPageMap = _.keyBy(privilegedPages, 'path')
  const missedPermissionStr = _.flow(
    () => _.filter(paths, path => !(confUtil.getUrl(path) in privilegedPageMap)),
    getPermissionStr
  )()
  console.log({ props, privilegedPageMap, missedPermissionStr })
  return (
    <NothingBlock
      className={cx(
        styles.noPermission,
        styles.updateListingInfo
      )}
      iconType='ec-block-people'
    >
      <p>
        <span>
          修改賣場資訊為複合式提案，您需同時擁有
          {REQUIRED_PERMISSION_STR}
          功能之提案方能使用。
        </span>
      </p>
      <br />
      <p>
        <span>
          您目前缺少：
          {missedPermissionStr}
          權限，請聯繫貴公司管理者至「小幫手權限管理設定」設定權限即可。
        </span>
      </p>
    </NothingBlock>
  )
}

const mapStateToProps = state => {
  const privilegedPages = _.get(state, 'page.privilegedPages')
  return { privilegedPages }
}

export default connect(mapStateToProps)(UpdateListingNoPrivilegedPermission)
